import Vue from 'vue';
import Vuex from 'vuex';
import client from 'api-client';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    registration: {
      name: null,
      surname: null,
      email: null,
      institution: null,
      password: null,
      confirmPassword: null,
      confirmDuplicate: false,
      touAccepted: false
    },
    registrationErrors: {},
    confirmationLinkEmail: null,
    registrationResult: null,
    login: {
      username: null,
      password: null,
      error: null
    },
    loggedIn: false,
    loading: false
  },
  mutations: {
    setLoading(state, value) {
      state.loading = value;
    },
    setConfirmationLinkEmail(state, value) {
      state.confirmationLinkEmail = value;
    },
    setRegistrationResult(state, value) {
      state.registrationResult = value;
    },
    setConfirmDuplicate(state, value) {
      state.registration.confirmDuplicate = value;
    },
    resetRegistrationErrors(state) {
      for (const key of Object.keys(state.registrationErrors)) {
        Vue.set(state.registrationErrors, key, null);
      }
    },
    setRegistrationErrors(state, response) {
      if (response.errors) {
        for (let i = 0; i < response.errors.length; i++) {
          let error = response.errors[i];
          Vue.set(state.registrationErrors, error.field, error.defaultMessage);
        }
      } else if (response.message === "Passwords don't match") {
        state.registrationErrors.password = response.message;
        state.registrationErrors.confirmPassword = response.message;
      } else {
        let event = new CustomEvent('apiError');
        event.message = {
          title: 'Error',
          body: response.message
        };
        document.dispatchEvent(event);
      }
    },
    resetRegistrationData(state) {
      state.registration.name = null;
      state.registration.surname = null;
      state.registration.email = null;
      state.registration.institution = null;
      state.registration.password = null;
      state.registration.confirmPassword = null;
      state.registration.confirmDuplicate = false;
      state.registration.touAccepted = false;
    },
    setLoginError(state, value) {
      state.login.error = value;
    },
    setLoggedIn(state, value) {
      state.loggedIn = value;
      if (!value) {
        state.login.username = null;
      }
      state.login.password = null;
      state.login.error = null;
    },
    setUsername(state, value) {
      state.login.username = value;
      state.loggedIn = value !== null;
      if (value) {
        state.login.password = null;
      }
      state.login.error = null;
    }
  },
  actions: {
    register({ state, commit }, $bvModal) {
      commit('setRegistrationResult', null);
      commit('setConfirmationLinkEmail', null)
      commit('resetRegistrationErrors');
      client.register(state.registration)
        .then(res => {
          commit('setRegistrationResult', res.result);
          switch (res.result) {
            case 'DONE':
              commit('setConfirmationLinkEmail', state.registration.email);
              commit('resetRegistrationData');
              break;
            case 'ALREADY_IN_RAP':
              $bvModal.show('confirm-duplicate-modal');
              break;
          }
        })
        .catch(res => commit('setRegistrationErrors', res));
    },
    confirmDuplicate({ commit, dispatch }) {
      commit('setConfirmDuplicate', true);
      dispatch('register');
    }
  }
});
